import { render, staticRenderFns } from "./SidenavItem.vue?vue&type=template&id=11b3772c&scoped=true&"
import script from "./SidenavItem.vue?vue&type=script&lang=js&"
export * from "./SidenavItem.vue?vue&type=script&lang=js&"
import style0 from "./SidenavItem.vue?vue&type=style&index=0&id=11b3772c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b3772c",
  null
  
)

export default component.exports